import React from 'react';
import cn from 'classnames';
import type { FormatOptionLabelMeta } from 'react-select';

import { Select } from 'components/shared/Select';
import { Typography } from 'components/shared/Typography';

import { SchoolPreview } from 'components/SchoolPreview';

import type { CoursesLessonsSchoolOption } from '../../CoursesLessonsPage.hooks';

import styles from './CoursesLessonsSchoolSelect.module.scss';

const formatSchoolLanguage = (language: string) => language.toUpperCase();

const formatOptionLabel = (
  option: CoursesLessonsSchoolOption,
  { context }: FormatOptionLabelMeta<CoursesLessonsSchoolOption>,
) => {
  const isValueContext = context === 'value';

  return (
    <span
      className={cn(styles.optionContent, {
        [styles.optionContentCompact]: isValueContext,
      })}
    >
      <SchoolPreview
        className={cn(styles.schoolPreview, {
          [styles.schoolPreviewMenu]: !isValueContext,
        })}
        preview={option.preview}
        name={option.name}
      />
      <Typography
        className={styles.schoolName}
        variant="body3"
        weight="medium"
        mode="compact"
        component="span"
      >
        {option.name}
      </Typography>
      {option.language ? (
        <Typography
          className={styles.language}
          variant="caption"
          mode="compact"
          component="span"
        >
          {formatSchoolLanguage(option.language)}
        </Typography>
      ) : null}
    </span>
  );
};

const CoursesLessonsSchoolSelect = ({
  className,
  options,
  value,
  placeholder,
  onChange,
}: {
  className?: string;
  options: CoursesLessonsSchoolOption[];
  value: CoursesLessonsSchoolOption | null;
  placeholder: string;
  onChange: (option: CoursesLessonsSchoolOption | null) => void;
}) => (
  <Select
    className={className}
    searchable
    hideSelectedOptions={false}
    options={options}
    value={value}
    placeholder={placeholder}
    formatOptionLabel={formatOptionLabel}
    onChange={onChange}
  />
);

export default React.memo(CoursesLessonsSchoolSelect) as any;
